export var CDN_HOST = 'https://cdn.myshopline.com';
var COM_DOMAIN = 'com';
var CN_DOMAIN = 'cn';
var getCdnHost = function getCdnHost(env, host) {
  function getHost(cdnDomain) {
    return "https://cdn.myshopline.".concat(cdnDomain);
  }
  // 测试环境，直接使用 oss 静态资源
  if (env === 'test') return getHost(CN_DOMAIN);
  var domainName = window.location.host.split('.').pop();
  // 默认情况下，中间页域名与主窗口域名保持一致
  var cdnHost = host ? host : getHost(domainName.toLowerCase() === COM_DOMAIN ? COM_DOMAIN : CN_DOMAIN);
  return cdnHost;
};
export var getCdnPath = function getCdnPath(env, host) {
  if (window.location.host.includes('localhost')) {
    return 'http://localhost:8080';
  } else {
    // FIXME：后续针对env extends 四个基本环境
    var cdnPrefix = env === 'prod' || env === 'prd' ? 'release' : env === 'pre' || env === 'prev' ? 'pre' : env;
    var cdnHost = getCdnHost(env, host);
    return "".concat(cdnHost, "/sl/admin/settlement-sdk/").concat(cdnPrefix);
  }
};